import React from 'react';
import styles from '../shared/TipComponents.module.scss';

/*Components */
import { ProductContainer } from '../../../shared/components/ProductContainer/ProductContainer';
import { TipHeader } from '../../components/TipHeader/TipHeader';
import { TipBox } from '../../components/TipBox/Box/TipBox';
import { TipAnalysisBoxConnected } from '../../components/TipAnalysisBox/TipAnalysisBox';
import { UnlockedTipBoxTopConnected } from '../../components/TipBox/Top/UnlockedTipBoxTop';

/* Interfaces */
import { FreeTipProduct, Tipster } from '../../interfaces/TipProduct';

interface FreeTipProps {
  tipster: Tipster;
  tip: FreeTipProduct;
}

export const FreeTipComponent: React.FC<FreeTipProps> = ({ tipster, tip }) => {
  return (
    <>
      <ProductContainer>
        <div className={styles.container}>
          <TipHeader type={tip.priceType} />

          <TipBox>
            <UnlockedTipBoxTopConnected />
          </TipBox>
        </div>
      </ProductContainer>

      <TipAnalysisBoxConnected />
    </>
  );
};
